import Common from "../../componets/Common";

export const generarBotonPagoVisa = (state) => {
  
  const form = document.createElement("form");

  form.setAttribute("method", "post");
  form.setAttribute(
    "action",
    `${Common.urlAPI}/ValidarPagoVisa/${state.total}/${state.invoice}?tk=${state.tv}&p=${state.invoice}&j=${state.jwt}`
  );
  form.setAttribute("id", "boton_pago");

  return form;
}
